<template>
    <v-dialog v-model="dialog_history" max-width="600px" @keydown.esc="close()">
        <v-card>
            <v-card-title>
                <span class="headline"
                    >Historial de {{ name }}
                </span>
            </v-card-title>

            <v-card-text>
                <v-data-table :headers="headers" :items="history" item-key="id">
                    <template v-slot:item="props">
                        <tr>
                            <td>{{ props.item.fecha_informada }}</td>
                            <td>{{ props.item.field }}</td>
                            <td>{{ props.item.fecha }}</td>
                            <td>{{ props.item.user.username }}</td>                                                   
                        </tr>
                    </template>
                </v-data-table>
            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="error" text @click="close()">Cerrar</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>

export default {
    name: "HistoryRestrasosModal",
    props: {},
    data() {
        return {            
            dialog_history: false,
            name: "",           
            history: [],
            headers: [
                { text: "Fecha Informada", align: "left", sortable: true, value: "fecha_informada" },
                { text: "Campo Fecha", value: "field" },
                { text: "Nueva Fecha", value: "fecha" },
                { text: "Usuario", value: "user.username" },
            ],
        };
    },
    mounted() {
        
    },
    computed: {},
    methods: {
        resetObject() {
            //this.mainItem = Object.assign({}, this.defaultItem);
        },
        close() {
            this.dialog_history = false;
            this.resetObject();
        },
        open(name,history_list) {
            this.dialog_history = true
            this.name = name;
            this.history = history_list            
        },
        /*
        get_history(assigned_id) {            
            if (assigned_id > 0) {
                
                assignatesTaskService.get_history_state_assigned_task(assigned_id)
                    .then(response => {    
                        console.log(response)
                        this.history = response.result;
                        this.dialog_history = true;
                    })
                    .catch(function(error) {
                        alert(error.request);
                        this.loading = false;
                    });
            }
        },  
        */      
    }
};
</script>
